export default __webpack_public_path__ + "static/case3-dd8cb4b23dc4a45b4277aa4adad6612c.png";